const formatConversion = value => Number(value || 0).toFixed(2);

export const buildUnitConversionPatch = (
  option,
  valueField = "sRelativeUnitCode",
) => {
  if (!option) return null;

  const selectedValue = option?.[valueField];
  const relativeUnitCode = option?.sRelativeUnitCode;

  if (
    selectedValue === undefined ||
    selectedValue === null ||
    relativeUnitCode === undefined ||
    relativeUnitCode === null
  ) {
    return null;
  }

  return {
    col_qty_select: selectedValue,
    sUnitConversion: `${relativeUnitCode}:${formatConversion(option?.sConversion)}`,
  };
};

export const reconcileUnitConversionRows = (
  rows,
  optionsByItem,
  valueField = "sRelativeUnitCode",
) => {
  let changed = false;
  const reconciled = rows.map(row => {
    if (!row?.col_item || !row?.col_qty_select) return row;

    const option = optionsByItem?.[row.col_item]?.find(
      candidate => candidate?.[valueField] === row.col_qty_select,
    );
    const patch = buildUnitConversionPatch(option, valueField);

    if (!patch || row.sUnitConversion === patch.sUnitConversion) return row;

    changed = true;
    return { ...row, ...patch };
  });

  return changed ? reconciled : rows;
};

export const createRowRequestOwnership = () => {
  const generations = new Map();

  const begin = (rowId, itemCode) => {
    const generation = (generations.get(rowId)?.generation || 0) + 1;
    const request = { rowId, itemCode, generation };
    generations.set(rowId, request);
    return request;
  };

  const isCurrent = request => {
    if (!request) return false;
    const current = generations.get(request.rowId);
    return current?.generation === request.generation &&
      current?.itemCode === request.itemCode;
  };

  const clear = rowId => {
    if (rowId === undefined) {
      generations.clear();
      return;
    }
    generations.delete(rowId);
  };

  return { begin, clear, isCurrent };
};
